/**
 * @generated SignedSource<<2d8282e2b14001d21280aac0dd817525>>
 * @relayHash bf457b573dda8d9ebb17800404d1a763
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf457b573dda8d9ebb17800404d1a763

import { ConcreteRequest } from 'relay-runtime';
export type ConsultQueueKind = "DOCTOR" | "MEDICAL_SUPERVISOR" | "OPERATIONS_LEAD" | "PEDIATRIC";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type ConsultQueueInput = {
  country: Country;
  language: Language;
  patientId?: string | null;
  phoneNumbers: ReadonlyArray<string>;
  queue: ConsultQueueKind;
};
export type useConsultQueueMutation$variables = {
  input: ConsultQueueInput;
};
export type useConsultQueueMutation$data = {
  readonly consultQueue: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AgentNotAuthenticated";
    } | {
      readonly __typename: "ConsultAlreadyInProgress";
    } | {
      readonly __typename: "ConsultRejected";
    } | {
      readonly __typename: "InvalidPatientPhoneNumber";
    } | {
      readonly __typename: "NoActiveCallFound";
    } | {
      readonly __typename: "PatientNotOnCall";
    } | {
      readonly __typename: "SeveralActiveCallsFound";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type useConsultQueueMutation = {
  response: useConsultQueueMutation$data;
  variables: useConsultQueueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConsultQueueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ConsultQueuePayload",
        "kind": "LinkedField",
        "name": "consultQueue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "AgentNotAuthenticated",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "InvalidPatientPhoneNumber",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "NoActiveCallFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "SeveralActiveCallsFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "PatientNotOnCall",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "ConsultAlreadyInProgress",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "ConsultRejected",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useConsultQueueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ConsultQueuePayload",
        "kind": "LinkedField",
        "name": "consultQueue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": (v2/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bf457b573dda8d9ebb17800404d1a763",
    "metadata": {},
    "name": "useConsultQueueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "68fd9da6fe9f823a0f647e9699271596";

export default node;
